import classNames from "classnames";
import React, { useMemo, type PropsWithChildren } from "react";
import { SvgSize } from "./svgSize";

interface SvgProps {
  additionalClass?: string;
  href: string;
  size?: SvgSize;
  title?: string;
}

export const Svg = ({
  href,
  additionalClass = "",
  size = SvgSize.LG,
  title
}: PropsWithChildren<SvgProps>) => {
  const sizeClasses = useMemo(() => {
    switch (size) {
      case SvgSize.XXL:
        return "w-2xl h-2xl";
      case SvgSize.XL:
        return "w-xl h-xl";
      case SvgSize.LG:
        return "w-lg h-lg";
      case SvgSize.MD:
        return "w-md h-md";
      case SvgSize.SM:
        return "w-sm h-sm";
      case SvgSize.Custom:
        return "";
      default:
        return "w-lg h-lg";
    }
  }, [size]);

  const useHref = href.includes("#") ? href : `${href}#icon`;

  return (
    <svg
      className={classNames(
        "flex-none flex justify-center items-center",
        sizeClasses,
        additionalClass
      )}
      focusable="false"
    >
      {title && <title>{title}</title>}
      <use href={useHref} />
    </svg>
  );
};
